'use client'

import { useEffect } from 'react'

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    document.documentElement.dataset.theme = 'light'
    document.documentElement.classList.remove('dark')
  }, [])

  return <>{children}</>
}
